import React from 'react';
import {TechseeBaseComponent} from '@techsee/techsee-ui-common/lib/_shared/techsee-base-component';
import {ISurroundingNetwork} from '../../../../../services/AngularServices/WifiAnalyzerService';
import {router, fullWifi, smallWifi, satelliteAltOutlined, smallTethering, locked} from '../../icons';
import {ITranslate} from '../../../../../services/LocalizationService';
import {observer} from 'mobx-react';

interface OtherNetworkBoxProps {
    device: ISurroundingNetwork;
    getDbmColor: (dbm: number | undefined) => string;
    isNetworkTab: boolean;
    translate: ITranslate;
}

@observer
export class OtherNetworkBox extends TechseeBaseComponent<OtherNetworkBoxProps> {
    renderInternal() {
        const {device, getDbmColor, isNetworkTab, translate} = this.props;

        return (
            <div className={`tab-box ${isNetworkTab ? 'active' : ''}`}>
                {isNetworkTab && (
                    <div className={`tab-box-icons-and-description`}>
                        <div className={'icon'}>{smallWifi}</div>
                        <span> {translate('CONNECTIVITY_GURU.WIFI_SCAN.NAME')} </span>
                        <span className='bold-text'>{device.ssid}</span>
                    </div>
                )}
                <div className='tab-box-icons-and-description'>
                    <div className={'icon'}>{router}</div>
                    <span>{`${translate('CONNECTIVITY_GURU.WIFI_SCAN.ACCESS_POINT')} ${device.macAddress}`}</span>
                </div>
                {device.signalStrengthPercentage != null && (
                    <div className={`tab-box-icons-and-description ${getDbmColor(device.rssi)}`}>
                        <div className={'icon'}>{fullWifi}</div>
                        <span> {translate('CONNECTIVITY_GURU.WIFI_SCAN.RSSI')} (%) </span>
                        <span>{device.signalStrengthPercentage}%</span>
                    </div>
                )}

                {device.rssi != null && (
                    <div className='tab-box-icons-and-description'>
                        <div className={'icon'}>{smallWifi}</div>
                        <span> {translate('CONNECTIVITY_GURU.WIFI_SCAN.RSSI_LEVEL')} </span>
                        <span className='bold-text'>
                            {device.rssi}
                            <span className='bold-text'> dBm </span>
                        </span>
                    </div>
                )}

                <div className='divider' />

                {device.channel && (
                    <div className='tab-box-icons-and-description'>
                        <div className={'icon'}>{smallTethering}</div>
                        <span> {translate('CONNECTIVITY_GURU.WIFI_SCAN.CHANNEL')} </span>
                        <span className='bold-text'>{device.channel}</span>
                    </div>
                )}

                <div className='tab-box-icons-and-description'>
                    <div className={'icon'}>{satelliteAltOutlined}</div>
                    <span> {translate('CONNECTIVITY_GURU.WIFI_SCAN.FREQUENCY')} </span>
                    <span className='bold-text'>{device.frequency ?? '2.4 GHz'}</span>
                </div>

                <div className='divider' />

                <div className='tab-box-icons-and-description margin-b-0'>
                    <div className='icon center'>{locked}</div>
                    <span> {translate('CONNECTIVITY_GURU.WIFI_SCAN.SECURITY')} </span>
                    <span className='bold-text'>{device.security || 'N/A'}</span>
                </div>
            </div>
        );
    }
}
